module.exports = __webpack_public_path__ + "static/equipment_module-1d738b114967ceef65002795565fdeff.jpg";